import { css, Theme, useTheme } from "@emotion/react";

import CrossWithCircle from "core/Components/Icons/CrossWithCircle";
import { NOOP } from "core/constants";

type Props = {
    onClose?: () => void,
}

const ConfirmationCloseButtonIcon = ({ onClose = NOOP } : Props) => {
    const theme: Theme = useTheme();

    const iconContainerStyle = css`
        position: absolute;
        top: 11px;
        right: 13px;

        ${theme.breakpoints.up('3xl')} {
            top: 13px;
            right: 16px;
        }

        ${theme.breakpoints.only('md')} {
            top: 13px;
            right: 16px;
        }

        ${theme.breakpoints.only('sm')} {
            top: 10px;
            right: 11px;
        }
    `;

    const iconStyle = css`
        width: 35px;
        height: 35px;
        cursor: pointer;

        ${theme.breakpoints.up('3xl')} {
            width: 43px;
            height: 43px;
        }

        ${theme.breakpoints.only('md')} {
            width: 43px;
            height: 43px;
        }

        ${theme.breakpoints.only('sm')} {
            width: 27px;
            height: 27px;
        }
    `;

    return (
        <div css={iconContainerStyle} onClick={onClose}>
            <CrossWithCircle backgroundColour={theme.colours.gray} css={iconStyle} />
        </div>
    );
};

export default ConfirmationCloseButtonIcon;